export function openFilter() {
	if (document.querySelector('#filter-icon') && document.querySelector('.section--search')) {
		document.querySelector('#filter-icon').addEventListener('click', function () {
			document.querySelector('.site__content').classList.toggle('filter--open')
		})
	}

	if (document.querySelector('.search-button') && document.querySelector('.section--search')) {
		document.querySelectorAll('.search-button').forEach((button) => {
			button.addEventListener('click', function () {
				document.querySelector('.site__content').classList.toggle('filter--open')
				document.querySelector('#listing').scrollIntoView()
			})
		})
	}

	if (document.querySelectorAll('.button--filter').length == 1 && document.querySelector('.section--search')) {
		document.querySelector('.button--filter').addEventListener('click', function () {
			document.querySelector('.site__content').classList.remove('filter--open')
			scrollTo(0, 0)
		})
	}
}
